(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inventa-legal-page"] && !Shopify.designMode) return;
  try {
    
function initLegalPages() {
  document.querySelectorAll('[data-legal-page]:not([data-ready])').forEach(root => {
    const content = root.querySelector('.inventa-legal__content');
    const navigation = root.querySelector('details');
    if (root.dataset.legalIcon === 'document') {
      const subtitle = content.querySelector(':scope > h5');
      if (subtitle) {
        const text = document.createElement('p'); text.textContent = subtitle.textContent;
        let description = root.querySelector('.inventa-page-header__description');
        if (!description) {
          description = document.createElement('div');
          description.className = 'inventa-page-header__description inventa-type-body';
          root.querySelector('.inventa-page-header__copy').append(description);
        }
        description.append(text); subtitle.remove();
      }
    }
    const numbered = /^\s*\d+\.\s+\S/;
    Array.from(content.querySelectorAll('p > strong')).filter(el => numbered.test(el.textContent)).forEach(strong => {
      const paragraph = strong.parentElement;
      const before = document.createRange(); before.selectNodeContents(paragraph); before.setEndBefore(strong);
      const after = document.createRange(); after.selectNodeContents(paragraph); after.setStartAfter(strong);
      const leading = document.createElement('p'); leading.append(before.cloneContents());
      const trailing = document.createElement('p'); trailing.append(after.cloneContents());
      const heading = document.createElement('h2'); heading.textContent = strong.textContent;
      paragraph.replaceWith(leading, heading, trailing);
    });
    const headings = Array.from(content.querySelectorAll(':scope > h2'));
    headings.forEach(heading => heading.classList.add('inventa-type-section'));
    if (!headings.length) return;
    const list = navigation.querySelector('ol');
    let group;
    Array.from(content.childNodes).forEach(node => {
      if (node.nodeType === 1 && node.tagName === 'H2') {
        group = document.createElement('section'); group.className = 'inventa-legal__section';
        content.insertBefore(group, node);
        const index = headings.indexOf(node) + 1;
        node.id = 'legal-' + index + '-' + node.textContent.trim().toLowerCase().replace(/^\d+\.\s*/, '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '');
        node.tabIndex = -1;
        group.setAttribute('aria-labelledby', node.id);
        if (/^\s*\d+\.\s*(Verantwortlicher|Ihre Rechte)\s*$/.test(node.textContent)) group.classList.add('inventa-legal__section--highlight');
        const item = document.createElement('li'); const link = document.createElement('a');
        link.className = 'inventa-link inventa-link--navigation inventa-type-compact'; link.href = '#' + node.id; link.textContent = node.textContent; item.append(link); list.append(item);
        {
          const parts = node.textContent.match(/^(\s*\d+\.\s*)([\s\S]*)$/);
          if (parts) {
            const number = document.createElement('span'); number.className = 'inventa-legal__number'; number.textContent = parts[1];
            node.replaceChildren(number, document.createTextNode(parts[2]));
          }
        }
      }
      if (group) group.append(node);
    });
    const desktop = matchMedia('(min-width:1000px)');
    const update = () => { navigation.open = desktop.matches; };
    update(); desktop.addEventListener('change', update);
    navigation.addEventListener('click', event => {
      const link = event.target.closest('a'); if (!link) return;
      if (!desktop.matches) navigation.open = false;
      const target = document.getElementById(link.hash.slice(1));
      if (target) target.focus({preventScroll:true});
    });
    navigation.hidden = false; root.dataset.ready = 'true';
  });
}
initLegalPages();
document.addEventListener('DOMContentLoaded', initLegalPages, {once:true});
document.addEventListener('shopify:section:load', initLegalPages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inventa-manufacturers"] && !Shopify.designMode) return;
  try {
    
function initManufacturers(){document.querySelectorAll('[data-makers]:not([data-ready])').forEach(root=>{root.dataset.ready='true';const input=root.querySelector('input');const items=[...root.querySelectorAll('.inventa-makers__item')];const groups=[...root.querySelectorAll('.inventa-makers__group')];const letters=[...root.querySelectorAll('.inventa-makers__alphabet a')];const normalize=text=>text.trim().replace(/\s+/g,' ').toLocaleLowerCase('de');const update=()=>{const q=normalize(input.value);let count=0;items.forEach(item=>{item.hidden=!normalize(item.dataset.name).includes(q);if(!item.hidden)count++});groups.forEach(group=>{group.hidden=!group.querySelector('.inventa-makers__item:not([hidden])')});letters.forEach(a=>{a.hidden=groups.find(g=>g.dataset.letter===a.dataset.letter).hidden});root.querySelector('.inventa-makers__empty').hidden=count!==0;const searching=Boolean(q);const top=root.querySelector('.inventa-makers__top');if(top)top.hidden=searching;root.querySelector('.inventa-makers__clear').hidden=!input.value;root.querySelector('.inventa-makers__alphabet').hidden=searching;root.querySelector('[data-list-title]').textContent=searching?root.dataset.resultsTitle:root.dataset.allTitle;root.querySelector('[data-result-count]').textContent=searching?root.dataset.resultsCount.replace('__COUNT__',String(count)):'';};input.addEventListener('input',update);root.querySelector('.inventa-makers__clear').addEventListener('click',()=>{input.value='';update();input.focus();});update();});}
initManufacturers();document.addEventListener('DOMContentLoaded',initManufacturers,{once:true});document.addEventListener('shopify:section:load',initManufacturers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inventa-screenfitter"]) return;
  try {
    
let screenFitterModule;
if (!customElements.get('inventa-screenfitter')) {
  customElements.define('inventa-screenfitter', class extends HTMLElement {
    connectedCallback() {
      if (this.mounted) return;
      this.mounted = true;
      const generation = this.generation = (this.generation || 0) + 1;
      const frame = this.querySelector('iframe');
      if (!frame) return;
      screenFitterModule ||= import('https://cdn.jsdelivr.net/npm/@open-iframe-resizer/core@latest/dist/index.min.js').catch(() => {
        screenFitterModule = null;
        return null;
      });
      screenFitterModule.then(async module => {
        if (!module || !this.isConnected || generation !== this.generation) return;
        try {
          const subscriptions = await module.initialize({targetElementSelector: '.content-section.section-fill'}, frame);
          if (!this.isConnected || generation !== this.generation) {
            subscriptions.forEach(subscription => subscription.unsubscribe());
            return;
          }
          this.subscriptions = subscriptions;
        } catch {
          if (generation === this.generation) this.subscriptions = null;
        }
      });
    }
    disconnectedCallback() {
      this.mounted = false;
      this.generation = (this.generation || 0) + 1;
      this.subscriptions?.forEach(subscription => subscription.unsubscribe());
      this.subscriptions = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
